import classNames from "classnames"
import { forwardRef, PropsWithChildren } from "react"
import styles from "./FlexColumn.module.scss"

interface IFlexColumnProps {
    className?: string
}
const FlexColumn = forwardRef<HTMLDivElement, PropsWithChildren<IFlexColumnProps>>((props, ref) => {
    return (
        <div className={classNames(props.className, styles.root)} ref={ref}>
            {props.children}
        </div>
    )
})

export default FlexColumn
